<nha-popup #nhaPopup [isClick]="true" (openChanged)="openChanged($event)" nhaTest="notification-menu-popup" contentClass="notification-menu-popup-content">
	<button
		mat-icon-button
		popup-target
		class="notification-bell-target"
		[class.is-open]="nhaPopup.isOpen"
		[class.is-ringing]="isRinging()"
		[matBadge]="badgeText()"
		[matBadgeHidden]="!showBadge()"
		nhaTest="notification-bell"
		aria-label="Notifications"
		[attr.aria-expanded]="nhaPopup.isOpen"
		(animationend)="ringAnimationDone()"
	>
		<mat-icon>notifications</mat-icon>
	</button>

	<div class="notification-menu" popup-content nhaTest="notification-menu-panel">
		<div class="panel-header">
			<h2>Notifications</h2>
			<button type="button" class="mark-all-read" [disabled]="!canMarkAllRead()" (click)="markAllRead()" nhaTest="mark-all-read">Mark all as read</button>
		</div>

		<div class="panel-body">
			@if (isLoading()) {
				@for (row of [1, 2, 3]; track row) {
					<div class="skeleton-row">
						<div class="skeleton-meta">
							<nha-skeleton width="76px" height="18px" radius="4px"></nha-skeleton>
							<nha-skeleton width="48px" height="12px" radius="4px"></nha-skeleton>
						</div>
						<nha-skeleton width="60%" height="14px" radius="4px"></nha-skeleton>
						<nha-skeleton width="100%" height="12px" radius="4px"></nha-skeleton>
						<nha-skeleton width="85%" height="12px" radius="4px"></nha-skeleton>
					</div>
				}
			} @else if (hasError()) {
				<div class="panel-error">
					<nha-alert-box type="error" message="Couldn't load notifications."></nha-alert-box>
					<button type="button" class="retry-link" (click)="retry()" nhaTest="notification-retry">Try again</button>
				</div>
			} @else if (notifications().length === 0) {
				<div class="panel-empty" nhaTest="notification-empty">
					<mat-icon>notifications_off</mat-icon>
					<div class="empty-title">You're all caught up</div>
					<div class="empty-subline">New notifications from your myNHA apps will show up here.</div>
				</div>
			} @else {
				@for (notification of notifications(); track notification.notificationID) {
					<button
						type="button"
						class="notification-row"
						[class.unread]="!notification.isRead"
						(click)="notificationClicked(notification)"
						nhaTest="notification-row"
					>
						<div class="row-meta">
							<span
								class="app-chip"
								[style.background-color]="notification.isRead ? notification.app.tintColor : notification.app.color"
								[style.color]="notification.isRead ? notification.app.tintTextColor : 'var(--nha-color-white)'"
							>
								{{ notification.app.appName }}
							</span>
							<span class="row-time">{{ relativeTime(notification.createdDate) }}</span>
						</div>
						<div class="row-subject">{{ notification.subject }}</div>
						<div class="row-message">{{ notification.message }}</div>
					</button>
				}

				@if (isLoadingMore()) {
					@for (row of [1, 2]; track row) {
						<div class="skeleton-row">
							<div class="skeleton-meta">
								<nha-skeleton width="76px" height="18px" radius="4px"></nha-skeleton>
								<nha-skeleton width="48px" height="12px" radius="4px"></nha-skeleton>
							</div>
							<nha-skeleton width="60%" height="14px" radius="4px"></nha-skeleton>
							<nha-skeleton width="100%" height="12px" radius="4px"></nha-skeleton>
						</div>
					}
				} @else if (hasMore()) {
					<button type="button" class="load-more" (click)="loadMore()" nhaTest="notification-load-more">Load more</button>
				}
			}
		</div>

		<div class="panel-footer">
			<button type="button" class="settings-link" (click)="openSettings(nhaPopup)" nhaTest="notification-settings-link">
				<mat-icon>settings</mat-icon>
				Notification settings
			</button>
			<button
				type="button"
				class="settings-link"
				*ifHasEntitlement="'Core:Feature|Admin:Access'"
				(click)="sendTestNotification()"
				nhaTest="notification-send-test"
			>
				<mat-icon>notification_add</mat-icon>
				Send test
			</button>
		</div>
	</div>
</nha-popup>
